import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';
import { AvatarService } from '../../../core-services';

type AvatarSize = 'small' | 'large';

@Component({
    selector: 'avatar-profile',
    templateUrl: './avatar-profile.component.html',
    styleUrls: ['./avatar-profile.component.less'],
    standalone: false
})
export class AvatarProfileComponent {
    /**
     * Small size is 36x36. Large size is 75x75
     */
    @Input() size: AvatarSize = 'small';

    private _button: boolean;

    constructor(public avatarService: AvatarService) {}

    /**
     * Adds the correct cursor styling
     */
    @Input()
    get button() {
        return this._button;
    }

    set button(value: any) {
        this._button = coerceBooleanProperty(value);
    }
}
